export default "__VITE_ASSET__C1PubJ7B__"